import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { SettingsService } from "src/app/services/settings.service";
import { Subject } from "rxjs";

import { SnackbarComponent } from './../snackbar/snackbar.component';
import { HeaderService } from "../header/header.service";
import { filter, takeUntil } from "rxjs/operators";
import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";

@Component({
  selector: "app-shipment-velocity",
  templateUrl: "./shipment-velocity.component.html",
  styleUrls: ["./shipment-velocity.component.scss"],
})
export class ShipmentVelocityComponent implements OnInit,OnDestroy {
  showLoader:boolean=false;
  settingsForm: FormGroup;
  filterPoId = new FormControl();
  page:string;
  spin:boolean=false;
  private destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ShipmentVelocityComponent>,
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
    public gridActionsService: GridActionsService,
    public headerService:HeaderService,
    private priceyardService : PriceyardService
  ) {
    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "SaveSettings"))
    .subscribe((e) => {
      const index= this.settingsService.saveSettingSignalRIds.findIndex(res=>res.id == e.id);
      if (e.response && e.response?.responseType !== "error" && index !== -1) {
        this.settingsService.saveSettingSignalRIds.splice(index,1);
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Velocity Settings saved successfully',
                action: 'Dismiss',
                type: 'success',
              },
            }
          );
          this.dialogRef.close("Save");
        this.showLoader = false;
       } else if(e.response && e.response?.responseType == "error" && index !== -1){
        this.settingsService.saveSettingSignalRIds.splice(index,1);
        this.showLoader = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e.response?.message, 
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
    });
  }

  ngOnDestroy(): void {
   this.destroy$.next();
   this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.page = this.data.page;
     if(!this.data.isPoFilter){
       this.getSettings();
     } else{
      this.filterPoId.setValue(this.data.currentValue);
     }
  }
  
  getSettingsKeys(): string[] {
    if (this.page === "replenish") {
      return [
        "restockdays",
        "replenishnostock",
      ];
    }else {
      return [
        "purchase days",
        "velocity perc",
        "replenish velocity perc",
        "restockdays",
        "replenishnostock",
        "ignoreBelowMin",    
        'yearlytrend'
      ]
    }
  }

  getSettings(){
    const payload = this.getSettingsKeys();
    this.settingsService.GetSettings(payload).pipe(takeUntil(this.destroy$)).subscribe((res: any[]) => {
      if (res) {
        if (this.page === "replenish") {
          const minDays = res.find(
            (x) => x.name === SettingsKeyMap["minDays"]
          );
          const replenishnostock = res.find(
            (x) => x.name === SettingsKeyMap["replenishnostock"]
          );
          this.settingsForm = new FormGroup({
            minDays: new FormControl(minDays ? minDays.on1 : 0 ),
            replenishnostock: new FormControl( replenishnostock ? replenishnostock.isOn : false),
          });
        }else if (this.page === "purchasing" || this.page === 'purchase-by-sku') {
          const purchaseDays = res.find(
            (x) => x.name === SettingsKeyMap["purchaseDays"]
          );
          const ignoreBelowMin = res.find(
            (x) => x.name === SettingsKeyMap["ignoreBelowMin"]
          );
          this.settingsForm = new FormGroup({
            purchaseDays: new FormControl(purchaseDays ? purchaseDays.on1 : ""),
            useStockDays: new FormControl(
              purchaseDays ? purchaseDays.isOn : true
            ),
            ignoreBelowMin: new FormControl(
              ignoreBelowMin ? ignoreBelowMin.isOn : ""
            ),
          });   
          if (!purchaseDays.isOn) {
            this.settingsForm.get("purchaseDays").disable();
          }
          this.settingsForm.get("useStockDays").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
            if (e) {
              this.settingsForm.get("purchaseDays").enable();
            } else {
              this.settingsForm.get("purchaseDays").disable();
            }
          });
      }
    }
    })
  }
  saveSettings(): void {
    this.showLoader = true;
    const form = this.settingsForm.getRawValue();
    const payload = [];

    Object.keys(form).forEach((key) => {
      if (form[key] !== undefined) {
        if (key === "purchaseDays" || key === "minDays") {
          if (form[key]) {    
            payload.push({
              name: SettingsKeyMap[key],
              on1: form[key],
            });
        }
       } else {
        const payloadIndex = payload.findIndex(
          (x) => x.name === SettingsKeyMap[key]
        );
        if (payloadIndex > -1) {
          payload[payloadIndex].isOn = form[key];
        } else {
          payload.push({
            name: SettingsKeyMap[key],
            isOn: form[key] ? true : false,
          });
        }
      }
    }
    });

    this.settingsService.SaveSettingsSignalR(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.settingsService.saveSettingSignalRIds.push({id:res.id});  
      },
     error: (err) => {
      this.showLoader = false
     }
   });
  }


  cancel() {
    this.dialogRef.close();
  }

  redirectToSettings(){
    window.open('/settings/system-settings?tab=Forecasting', '_blank');
  }

  savePOFilter(){
    this.spin=true;
    this.priceyardService.GetSkusForPoId(this.filterPoId.value).pipe(takeUntil(this.destroy$)).subscribe({
    next: (res:any[]) => {
      this.spin=false;
      if(res.length){
        const response={
          filterPoId:this.filterPoId.value,
          skus:res
        }
       this.dialogRef.close(response);
      } else{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: "This poId has no skus to filter",
              action: 'Dismiss',
              type: 'info',
            },
          }
        );
      }     
    },
   error: (err) => {
      this.spin=false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err?.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }
}


const SettingsKeyMap = {
  'minDays': "restockdays",
  "purchaseDays": 'purchase days',
  "useStockDays": 'purchase days',
  "ignoreBelowMin": "ignoreBelowMin",
  'replenishnostock': 'replenishnostock',
}